import { createApiEffect } from '@/features/api/common/create-api-effect'
import { RegistrationsType } from '@/pages/users/students/list/model/types'

export const getRegistrationFilterFx = createApiEffect<void, RegistrationsType[]>({
  requestMapper: () => ({
    method: 'GET',
    url: '/api/user-app/student/filter/register-by-services/',
  }),
})
